// semeia-disable-reexport
export default [{
  classCode: "10",
  displayName: "Comptes rendus",
  typeCodes: [{
    typeCode: "15508-5",
    typeCodeDisplayName: "CR d'accouchement"
  }, {
    typeCode: "70004-7",
    typeCodeDisplayName: "CR d'acte diagnostique (autre)"
  }, {
    typeCode: "75492-9",
    typeCodeDisplayName: "CR d'acte diagnostique à visée préventive ou de dépistage"
  }, {
    typeCode: "11505-5",
    typeCodeDisplayName: "CR d'acte thérapeutique (autre)"
  }, {
    typeCode: "75482-0",
    typeCodeDisplayName: "CR d'acte thérapeutique à visée préventive"
  }, {
    typeCode: "67851-6",
    typeCodeDisplayName: "CR d'admission"
  }, {
    typeCode: "11526-1",
    typeCodeDisplayName: "CR d'anatomie et de cytologie pathologiques"
  }, {
    typeCode: "77436-4",
    typeCodeDisplayName: "CR d'anesthésie"
  }, {
    typeCode: "BIL_AUTO",
    typeCodeDisplayName: "CR de bilan d'évaluation de la perte d'autonomie"
  }, {
    typeCode: "47420-5",
    typeCodeDisplayName: "CR de bilan fonctionnel (par auxiliaire médical)"
  }, {
    typeCode: "34749-2",
    typeCodeDisplayName: "CR de consultation pré-anesthésique"
  }, {
    typeCode: "51969-4",
    typeCodeDisplayName: "CR de génétique moléculaire"
  }, {
    typeCode: "15507-7",
    typeCodeDisplayName: "CR de passage aux urgences"
  }, {
    typeCode: "34794-8",
    typeCodeDisplayName: "CR de réunion de concertation pluridisciplinaire"
  }, {
    typeCode: "75497-8",
    typeCodeDisplayName: "CR de télé-médecine"
  }, {
    typeCode: "11502-2",
    typeCodeDisplayName: "CR d'examens biologiques"
  }, {
    typeCode: "34112-3",
    typeCodeDisplayName: "CR hospitalier (séjour)"
  }, {
    typeCode: "34874-8",
    typeCodeDisplayName: "CR opératoire"
  }, {
    typeCode: "11488-4",
    typeCodeDisplayName: "CR ou fiche de consultation ou de visite"
  }, {
    typeCode: "11506-3",
    typeCodeDisplayName: "CR ou fiche de suivi de soins par auxiliaire médical"
  }, {
    typeCode: "11490-0",
    typeCodeDisplayName: "Lettre de liaison à la sortie d'un établissement de soins"
  }]
}, {
  classCode: "11",
  displayName: "Synthèses",
  typeCodes: [{
    typeCode: "18761-7",
    typeCodeDisplayName: "Note de transfert (dont lettre de liaison à l’entrée en établissement de soins)"
  }, {
    typeCode: "34133-9",
    typeCodeDisplayName: "Synthèse d'épisode de soins"
  }, {
    typeCode: "60591-5",
    typeCodeDisplayName: "Synthèse du dossier médical"
  }]
}, {
  classCode: "31",
  displayName: "Imagerie médicale",
  typeCodes: [{
    typeCode: "18748-4",
    typeCodeDisplayName: "CR d'imagerie médicale"
  }, {
    typeCode: "52040-3",
    typeCodeDisplayName: "Document encapsulant une image d'illustration non DICOM"
  }
  // {
  //   typeCode: "Code procédure variable (c)",
  //   typeCodeDisplayName:
  //     "Nom de la procédure à l'origine d'objets d'imagerie accessibles en format DICOM"
  // }
  ]
}, {
  classCode: "42",
  displayName: "Prescription",
  typeCodes: [{
    typeCode: "57828-6",
    typeCodeDisplayName: "Prescription (autre)"
  }, {
    typeCode: "57833-6",
    typeCodeDisplayName: "Prescription de médicaments"
  }, {
    typeCode: "57832-8",
    typeCodeDisplayName: "Prescription de soins"
  }]
}, {
  classCode: "43",
  displayName: "Dispensations",
  typeCodes: [{
    typeCode: "DISP_AUT",
    typeCodeDisplayName: "Dispensation (autre)"
  }, {
    typeCode: "60593-1",
    typeCodeDisplayName: "Dispensation médicamenteuse"
  }]
}, {
  classCode: "44",
  displayName: "Plans de soins, protocoles de soins",
  typeCodes: [{
    typeCode: "18776-5",
    typeCodeDisplayName: "Plan personnalisé de soins"
  }, {
    typeCode: "PROT_ALD",
    typeCodeDisplayName: "Protocole de soins ALD"
  }]
}, {
  classCode: "45",
  displayName: "Traitement administré",
  typeCodes: [{
    typeCode: "80565-5",
    typeCodeDisplayName: "CR d'administration de médicaments"
  }]
}, {
  classCode: "52",
  displayName: "Certificats et déclarations",
  typeCodes: [{
    typeCode: "CERT_DECL",
    typeCodeDisplayName: "Certificat, déclaration"
  }]
}, {
  classCode: "60",
  displayName: "Données de remboursement",
  typeCodes: [{
    typeCode: "REMB",
    typeCodeDisplayName: "Données de remboursement"
  }]
}, {
  classCode: "90",
  displayName: "Expression du titulaire",
  typeCodes: [{
    typeCode: "EXPPAT_3",
    typeCodeDisplayName: "Directives anticipées"
  }, {
    typeCode: "EXPPAT_2",
    typeCodeDisplayName: "Document du patient"
  }, {
    typeCode: "EXPPAT_1",
    typeCodeDisplayName: "Volontés et droits du patient"
  }]
}];